import Vue from "vue";
import VueRouter from "vue-router";
import auth from "../services/auth";
import store from "../store";
Vue.use(VueRouter);

const routes = [
  {
    path: "/ingresar",
    name: "sistema",
    children: [
      {
        path: "perfil/",
        name: "perfil",
        component: () => import("../views/PerfilView.vue"),
      },
      {
        path: "soporte-y-mantencion/",
        name: "soporte",
        component: () => import("../views/SoportesView.vue"),
        meta: {
          requirePermission: true,
          visible: "b_soporte",
        },
      },
      {
        path: "nuevos-desarrollos/",
        name: "desarrollos",
        component: () => import("../views/DesarrollosView.vue"),
        meta: {
          requirePermission: true,
          visible: "b_desarrollo",
        },
      },
      {
        path: "desarrollo-cliente/",
        name: "desarrollo-cliente",
        component: () => import("../views/PostProduccion.vue"),
        meta: {
          requirePermission: true,
          visible: "b_desarrollo_cliente",
        },
      },
      {
        path: "actualizaciones/",
        name: "actualizacion",
        component: () => import("../views/ActualizacionView.vue"),
        meta: {
          requirePermission: true,
          visible: "b_actualizacion",
        },
      },
      {
        path: "cotizaciones-y-mejoras/",
        name: "cotizacion",
        component: () => import("../views/CotizacionView.vue"),
        meta: {
          requirePermission: true,
          visible: "b_cotizacion",
        },
      },

      {
        path: "capacitaciones/",
        name: "capacitacion",
        component: () => import("../views/CapacitacionView.vue"),
        meta: {
          requirePermission: true,
          visible: "b_capacitacion",
        },
      },
      {
        path: "informe/",
        name: "informe",
        component: () => import("../views/InformeView.vue"),
        meta: {
          requirePermission: true,
          visible: "b_informe",
        },
      },
      {
        path: "cuenta/:ajuste",
        name: "cuenta",
        component: () => import("../views/CuentaView.vue"),
      },
      {
        path: "precios",
        name: "precios",
        component: () => import("../views/ListaPreciosView.vue"),
      },
      {
        path: "qa-cliente",
        name: "qa-cliente",
        component: () => import("../views/QAResponseView.vue"),
      },
      {
        path: "biblioteca",
        name: "biblioteca",
        component: () => import("../views/BibliotecaView.vue"),
      },
    ],
    redirect: "/ingresar/perfil",
    component: () => import("../views/SistemaView.vue"),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/",
    name: "login",
    component: () => import("../views/LoginView.vue"),
    meta: {
      requiresAuth: false,
      requiresRecaptcha: true,
    },
    children: [
      {
        path: "crear-contrasena/:param",
        name: "crear-contrasena",
        component: () => import("../components/login/RecuperarClave.vue"),
      },
    ],
  },
  {
    path: "/mantencion",
    name: "mantencion",
    component: () => import("../views/MantencionView.vue"),
  },
  {
    path: "*",
    redirect: "/",
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

router.beforeEach(async (to, from, next) => {
  if (to.name === "mantencion") {
    if (store.state.paramGenerales.mantencion) next();
    else next("/");
    return;
  } else if (
    to.name !== "mantencion" &&
    store.state.paramGenerales.mantencion
  ) {
    next("/mantencion");
    return;
  } else {
    if (to.matched.some((record) => record.meta.requiresAuth)) {
      if (auth.isAuthenticated()) {
        if (to.name == "cuenta" && to.params.ajuste == "cambiar-clave") next();
        else {
          if (auth.getUserLogged().b_cambia_clave)
            return next({
              name: "cuenta",
              params: { ajuste: "cambiar-clave" },
            });
          let forzadoQa =
            store.state.contadorTickets.ticket_qa > 0 &&
            store.getters.getParams["3134"]?.valor == 1;
          if (forzadoQa && to.name != "qa-cliente")
            return next({ name: "qa-cliente" });
          if (
            store.state.contadorTickets.ticket_qa == 0 &&
            to.name == "qa-cliente"
          )
            return next({ name: "perfil" });
          if (to.meta.requirePermission) {
            let bitState = store.state.bitsCliente[to.meta.visible];
            if (bitState) {
              return next();
            } else return next("/ingresar/perfil");
          } else return next();
        }
      } else {
        next("/");
      }
    } else {
      if (auth.isAuthenticated()) {
        next("/ingresar/perfil");
        return;
      } else {
        next();
      }
    }
  }
});

router.afterEach(async (to) => {
  // Carga la instancia cargada por el script de Google
  await Vue.prototype.$recaptchaLoaded();

  // 2. Accede a la instancia desde el prototipo de Vue
  const recaptcha = Vue.prototype.$recaptchaInstance;
  if (recaptcha) {
    if (to.meta.requiresRecaptcha) {
      recaptcha.showBadge();
    } else {
      recaptcha.hideBadge();
    }
  }
});

export default router;
